import { render, staticRenderFns } from "./NetworkSuppliers.html?vue&type=template&id=06b974b7&scoped=true&"
import script from "./NetworkSuppliers.js?vue&type=script&lang=js&"
export * from "./NetworkSuppliers.js?vue&type=script&lang=js&"
import style0 from "./NetworkSuppliers.scss?vue&type=style&index=0&id=06b974b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b974b7",
  null
  
)

export default component.exports